import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPhoneNumberLimits,
  handlePhoneNoChange,
  phoneNumberValidation,
} from "../../../Common/Validations";
import { setUnsavedChanges } from "../../../Redux/Slice/Common/SelectedTabSlice";
import { ALL_CALLING_CODES } from "../../../Common/Constants";
import { maskNoByCallingCode } from "../../../Common/utils";
import CountryPhoneInput from "../../../Common/CountryPhoneInput";

const PhoneNumberTab = ({
  isTabSelected,
  formData,
  setFormData,
  setHasChanged,
  formError,
  setFormError,
}) => {
  const dispatch = useDispatch();
  const { phoneNoListData } = useSelector((state) => state?.phoneNoList);
  const phoneNoList =
    phoneNoListData?.data && Array.isArray(phoneNoListData?.data)
      ? phoneNoListData?.data
      : [];

  const handleChange = (e) => {
    let { name, value, type, checked } = e.target;
    if (name == "fallbackDestinationPhoneNumber") {
      const phoneNoCountryCode = formData.fallbackDestinationCountryCode;
      const phoneNoErrorKey = "fallbackDestinationPhoneNumberError";

      handlePhoneNoChange(
        e,
        phoneNoCountryCode,
        () =>
          setFormData((prev) => ({
            ...prev,
            phoneNumber: {
              ...prev?.phoneNumber,
              [name]: value,
            },
          })),
        (newError) =>
          setFormError({ ...formError, [phoneNoErrorKey]: newError }),
        (isChanged) => {
          setHasChanged(isChanged);
          dispatch(setUnsavedChanges(true));
        },
        false
      );
    } else if (name == "fallbackDestinationCountryCode") {
      setHasChanged(true);
      dispatch(setUnsavedChanges(true));
      const phoneNo = formData.fallbackDestinationPhoneNumber;
      const phoneNoKey = "fallbackDestinationPhoneNumber";
      const phoneNoErrorKey = "fallbackDestinationPhoneNumberError";

      let formatted = phoneNo;
      setFormData((prev) => ({
        ...prev,
        phoneNumber: {
          ...prev?.phoneNumber,
          [name]: value,
          [phoneNoKey]: formatted,
        },
      }));
      const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
      const rawDigits = phoneNo?.replace(/\D/g, "");
      const isValid = phoneNumberValidation(rawDigits, value);
      setFormError({
        ...formError,
        [phoneNoErrorKey]:
          isValid || !value || !phoneNo
            ? ""
            : rawDigits.length < minDigits
            ? `Phone number must be at least ${minDigits} digits long.`
            : "Please enter a valid phone number",
      });
    } else {
      setHasChanged(true);
      dispatch(setUnsavedChanges(true));
      setFormData((prev) => ({
        ...prev,
        phoneNumber: {
          ...prev?.phoneNumber,
          [name]: type == "checkbox" ? checked : value,
        },
      }));
    }
  };

  return (
    <div
      className={
        isTabSelected
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      <div className="formRow">
        <div className="formCol">
          <div className="form__Field form__Field--full">
            <label for="inboundPhoneNumber" className="form__label">
              Inbound Phone Number
            </label>
            <select
              className="form__select form__select--sm"
              id="inboundPhoneNumber"
              name="inboundPhoneNumber"
              value={formData?.inboundPhoneNumber}
              onChange={handleChange}
            >
              <option selected="" value="" disabled>
                -Select-
              </option>
              {phoneNoList?.length
                ? phoneNoList.map((phone) => (
                    <option value={phone?.number}>{phone?.number}</option>
                  ))
                : ""}
            </select>
          </div>
          <p className="para para--right">
            <div className="form__checkbox__option m_0">
              <input
                type="checkbox"
                id="isPhoneNumberDefault"
                className="form__checkbox__input"
                value={formData?.isPhoneNumberDefault}
                name="isPhoneNumberDefault"
                checked={formData?.isPhoneNumberDefault ?? false}
                onChange={handleChange}
              />
              <label for="isDefaultEmail" className="form__checkbox__label">
                Make this phone number as default
              </label>
            </div>
          </p>
        </div>
        {formData?.inboundPhoneNumber ? (
          <div className="formCol">
            <div className="form__Field">
              <label for="phonenumber" className="form__label">
                Fallback Destination
              </label>
              <CountryPhoneInput
                countryCodeFieldName="fallbackDestinationCountryCode"
                phoneFieldName="fallbackDestinationPhoneNumber"
                countryCode={formData.fallbackDestinationCountryCode}
                phoneNumber={formData.fallbackDestinationPhoneNumber}
                onCountryChange={handleChange}
                onPhoneChange={handleChange}
              />
              {formError?.fallbackDestinationPhoneNumberError ? (
                <div className="form__error">
                  {formError?.fallbackDestinationPhoneNumberError}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        <div className="formRow">
          <div className="formCol">
            <div className="form__Field">
              <label
                for="inboundPhoneNumberPrompt"
                className="form__label form__label--flex"
              >
                Inbound call prompt
              </label>
              <textarea
                id="inboundPhoneNumberPrompt"
                name="inboundPhoneNumberPrompt"
                onChange={handleChange}
                value={formData?.inboundPhoneNumberPrompt}
                className="form__textarea"
                placeholder="Inbound call prompt"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberTab;
